document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-mm-variant]');
  if (!select) return;
  const form = document.getElementById(select.dataset.formId);
  const selected = select.options[select.selectedIndex];
  if (!selected) return;
  const button = form && form.querySelector('[data-mm-add]');
  const stockMessage = form && form.querySelector('[data-mm-stock]');
  const price = document.querySelector('[data-mm-price="' + select.dataset.formId + '"]');
  if (price) price.textContent = selected.dataset.price;
  if (button) {
    button.disabled = selected.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
  }
  if (stockMessage) stockMessage.hidden = selected.dataset.available === 'true';
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState({}, '', url.toString());
});
document.addEventListener('click', function (event) {
  if (!event.target.closest('.mm-mobile-nav a')) return;
  const menu = event.target.closest('.mm-mobile-nav');
  if (menu) menu.open = false;
});
